import { render, staticRenderFns } from "./dropdown-comment.vue?vue&type=template&id=5ab343f4&"
import script from "./dropdown-comment.vue?vue&type=script&lang=js&"
export * from "./dropdown-comment.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-comment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports